<h2 mat-dialog-title class="title-head">{{ title }}</h2>
<mat-progress-bar mode="indeterminate" color="primary" *ngIf="loading"></mat-progress-bar>

<mat-dialog-content class="mat-typography" appPerfectScrollbar>

  <p [innerHTML]="noti.message"></p>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">
    {{ cancelText }}
  </button>
  <button mat-button (click)="accept()">
    {{ accpetText }}
  </button>
</mat-dialog-actions>
